import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import Image from "gatsby-image"
import { graphql, useStaticQuery } from "gatsby"

import Underline from "../UI/Underline/underline"
import classes from "./hero.module.scss"
import SocialLinks from "../SocialLinks/socialLinks"

const Hero = () => {
  const { t } = useTranslation()
  const query = useStaticQuery(graphql`
    query {
      heroImg: file(relativePath: { eq: "images/web.png" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <header className={classes.Hero}>
      <div className={classes.CenterHero}>
        <div className={classes.Title}>
          <div>
            <Underline />
            <h1>
              {t("hero.greeting")}
              <span>{t("hero.position")}</span>
            </h1>
          </div>

          <SocialLinks listStyleClass={classes.SocialLinks} />
        </div>
        <Image
          className={classes.Image}
          fluid={query.heroImg.childImageSharp.fluid}
          alt="Hero Image"
          imgStyle={{
            objectFit: "contain",
            imageRendering: "-webkit-optimize-contrast",
          }}
        />
      </div>
    </header>
  )
}

export default Hero
